import * as React from 'react';

import type * as api from '@gitbook/api-client';
import * as analytics from '@gitbook/app-analytics/client';

import { apiClient } from '../../state';

/**
 * Actions to configure AI features for an organization.
 */
export function useConfigureAI(organization: api.Organization) {
    const enable = React.useCallback(
        async (from: 'settings' | 'search') => {
            await apiClient.organizations.updateOrganizationById(organization.id, {
                ai: true,
            });

            analytics.logEvent(
                analytics.createOrgEvent(organization, {
                    type: 'organization_enable_ai',
                    from,
                })
            );
        },
        [organization]
    );

    const disable = React.useCallback(async () => {
        await apiClient.organizations.updateOrganizationById(organization.id, {
            ai: false,
        });

        analytics.logEvent(
            analytics.createOrgEvent(organization, {
                type: 'organization_disable_ai',
            })
        );
    }, [organization]);

    return {
        enabled: !!organization.ai,
        enable,
        disable,
    };
}
